
interface NewsletterSignupProps {
  formUrl: string;
}

const NewsletterSignup = ({ formUrl }: NewsletterSignupProps) => {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const email = formData.get('email') as string;

    if (!email || !email.includes('@')) return;

    const statusEl = document.getElementById('newsletter-status');

    try {
      const params = new URLSearchParams();
      params.append('email', email);

      const res = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      if (res.ok) {
        if (statusEl) {
          statusEl.textContent = 'Thanks for subscribing! Check your inbox.';
          statusEl.className = 'text-sm text-teal-300 mt-2';
        }
        form.reset();
      } else {
        if (statusEl) {
          statusEl.textContent = 'Something went wrong. Please try again.';
          statusEl.className = 'text-sm text-red-400 mt-2';
        }
      }
    } catch {
      if (statusEl) {
        statusEl.textContent = 'Network error. Please try again.';
        statusEl.className = 'text-sm text-red-400 mt-2';
      }
    }
  };

  return (
    <section className="bg-gray-900 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-12 h-12 flex items-center justify-center bg-teal-500/20 rounded-xl mx-auto mb-4">
          <i className="ri-mail-send-line text-2xl text-teal-400"></i>
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">
          Get Weekly Tax Tips Delivered
        </h2>
        <p className="text-gray-400 mb-8 max-w-lg mx-auto">
          Join 12,000+ professionals who receive our city-specific tax strategies and financial planning insights every week.
        </p>
        <form
          id="blog-newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            required
            className="flex-1 px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-500 text-sm focus:outline-none focus:border-teal-500 transition-colors"
          />
          <button
            type="submit"
            className="px-6 py-3 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            Subscribe
          </button>
        </form>
        <p id="newsletter-status" className="text-sm text-gray-500 mt-2"></p>
        <p className="text-xs text-gray-600 mt-3">No spam. Unsubscribe anytime.</p>
      </div>
    </section>
  );
};

export default NewsletterSignup;
